import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import {
  Row,
  Col,
  Container,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import classNames from "classnames";
import Countdown, { zeroPad } from "react-countdown";
import moment from "moment";
import styled from "styled-components";

import {
  getCollectionPrefix,
  getCollectionList,
  getImageBanner,
  getCollectionProductBrands,
  getCollectionAllCategory
} from "../../../actions/kafairAction";

import { Banner } from "../../../Container/Assets";
import SneakerImage from "../../../components/Sneakers/SneakerImage";
import SneakerLoadingSpinner from "../../../components/Sneakers/SneakerLoadingSpinner";
import { TextRupiah } from "../../../components/Text";

import { getCloudImageUrl } from "../../../utils";

class MerchandiseProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      prevY: 0
    };
  }

  componentDidMount() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.6
    };

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    this.props.getImageBanner(
      "official-merchandise",
      "official_merchandise",
      "novembazaar"
    );

    this.getProductList();

    this.observer = new IntersectionObserver(
      this.handleObserver.bind(this),
      options
    );
    this.observer.observe(this.loadingRef);
  }

  componentDidUpdate(prevProps) {
    const { page } = this.state;
    const {
      data: { products }
    } = this.props;

    if (
      !products.isFetching &&
      prevProps.data.products.isFetching !== products.isFetching
    ) {
      const { status_code } = products;

      if (status_code === 200) {
        this.setState({
          page: page + 1
        });
      }
    }
  }

  handleObserver(entities, observer) {
    const { prevY, page } = this.state;
    const {
      data: {
        products: { hasMoreData }
      }
    } = this.props;

    const y = entities[0].boundingClientRect.y;
    if (hasMoreData !== null) {
      if (prevY > y) {
        this.getProductList();
      }
      this.setState({ prevY: y });
    }
  }

  getProductList = () => {
    const { page } = this.state;
    const payloadProducts = {
      collection: "official-merchandise",
      collection_type: "product_variants",
      page: 1,
      per_page: 30,
      pre_verified: true
    };

    this.props.getCollectionAllCategory(
      payloadProducts,
      "official_merchandise"
    );
  };

  renderProducts = () => {
    const {
      data: {
        title,
        isActive,
        // kafair: { imagesLandscape },
        products
      }
    } = this.props;

    if (products.data.length === 0) return null;

    return (
      <Row className="product-wrapper">
        {products.data.map((item, index) => {
          const category = item.product.category.name;

          return (
            <Col xs={6} md={4}>
              <a
                href={`/${category}/${item.id}/${item.slug}`}
              >
                <div
                  className={classNames("product-card", {
                    disabled: !item.price || item.out_of_stock
                  })}
                >
                  <span>
                    {item.product.brand.title
                      ? item.product.brand.title
                      : item.product.brand.name}
                  </span>
                  <span>{item.display_name}</span>
                  <SneakerImage
                    hasImage={
                      item.product_variant_images.length > 0 ? true : false
                    }
                    src={
                      item.product_variant_images.length
                        ? getCloudImageUrl(
                            item.product_variant_images[0].URL,
                            400
                          )
                        : null
                    }
                    alt={item.display_name}
                  />
                  {item.price ? (
                    <TextRupiah
                      value={item.price}
                      className="price-tag"
                      color="black"
                      bold={true}
                      align="center"
                    />
                  ) : (
                    <span className="text-center">X</span>
                  )}
                </div>
              </a>
            </Col>
          );
        })}
      </Row>
    );
  };

  render() {
    const { category } = this.state;
    const { dataSteals, match } = this.props;
    const {
      data: {
        title,
        isActive,
        description,
        kafair: { imagesLandscape },
        // mainBanner: { imagesLandscape, imagesPortrait },
        products
      }
    } = this.props;

    return (
      <Container fluid className="main-container" id="home-container" style={{ backgroundColor: "#24553e", marginTop: window.screen.availWidth < 450 ? "70px" : "-70px" }}>
        <Banner
          src={getCloudImageUrl(imagesLandscape, 1024)}
          alt={title}
          classNameBanner="event_banner"
        />
        <div className="steal-product-container">
          <TitleWrapper>
            <span>{title}</span>
            <span dangerouslySetInnerHTML={{ __html: description }} />
          </TitleWrapper>
          <Container>
            {this.renderProducts()}
            <div style={{ marginTop: "120px" }}>
              <SneakerLoadingSpinner
                isLoading={products.isFetching && this.state.page > 1}
                isHide={!products.isFetching}
                wrapperRef={loadingRef => (this.loadingRef = loadingRef)}
              />
            </div>
          </Container>
        </div>
      </Container>
    );
  }
}

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 15px 50px 15px;
  display: none;
  span {
    font-size: 20px;
    color: #4a4a4a;
    font-family: "Nunito Bold";
    text-align: center;
    text-transform: uppercase;
    &:nth-child(2) {
      font-size: 1rem;
      font-family: "Nunito Light";
      margin-top: 5px;
      text-transform: none;
    }
    strong {
      font-family: "Nunito Bold";
      text-transform: none;
    }
  }
  @media (max-width: 480px) {
    margin: 0;
    span {
      font-size: 1rem;
      &:nth-child(2) {
        font-size: 12px;
      }
    }
  }
`;

const mapStateToProps = state => ({
  data: state.dataKaFair.official_merchandise
});

const mapDispatchToProps = dispatch => ({
  getCollectionPrefix: (payload, name) =>
    dispatch(getCollectionPrefix(payload, name)),
  getCollectionList: (category, slug, payload, name) =>
    dispatch(getCollectionList(category, slug, payload, name)),
  getImageBanner: (slug, name, category) =>
    dispatch(getImageBanner(slug, name, category)),
  getCollectionProductBrands: (payload, name) =>
    dispatch(getCollectionProductBrands(payload, name)),
  getCollectionAllCategory: (payload, name) =>
    dispatch(getCollectionAllCategory(payload, name))
});

export default connect(mapStateToProps, mapDispatchToProps)(MerchandiseProduct);
